/** @format */

import React, { useState, useEffect } from "react";
import { useHistory } from "react-router";
import masterServices from "../../Services/masterService";
import { Modal } from "../../Components";
import Loader from "../../Components/Loader";
import { useLocation } from "react-router-dom";
import CheckAccess from "../../Function/CheckAccess";
// import { toast } from "react-toastify";

export const ProfitMarginList = () => {
  const history = useHistory();
  const [listData, setListData] = useState();
  // const [count] = useState(1);
  // eslint-disable-next-line
  const [pagination, setPagination] = useState({ page: 1, limit: 10 });
  // eslint-disable-next-line
  const [currentPage, setCurrentPage] = useState(1);
  const [loader, setLoader] = useState(true);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const location = useLocation();
  let user_type = localStorage.getItem("user_type");

  useEffect(() => {
    getItemList();
    // eslint-disable-next-line
  }, [currentPage]);

  const getItemList = () => {
    let param = { ...pagination, page: currentPage };
    if (pagination.search) {
      param["page"] = 1;
    }
    masterServices.get_profit_margin(param).then((res) => {
      if (res.status) {
        setLoader(false);
        setListData(res.data);
        // setPagination(res.pagination)
      } else {
        setLoader(false);
      }
    });
  };

  // const onPageChangeEvent = (e) => {
  //   setLoader(true);
  //   setCurrentPage(e.selected + 1);
  // };

  const onDeleteSubmit = () => {
    let postData = {
      id: isDeleteOpen._id,
      is_delete: "YES",
    };

    masterServices.delete_profit_margin(postData).then((res) => {
      if (res.status) {
        setIsDeleteOpen(false);
        getItemList();
      }
    });
  };

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-end mb-3">
              {/* <div>
                                <input
                                    type="text"
                                    className={'form-control'}
                                    placeholder="Search..."
                                />
                            </div> */}
              {(CheckAccess(212, "add") || user_type === "SUPERADMIN") && (
                <button
                  className="btn btn-primary w-sm waves-effect waves-light"
                  onClick={() => history.push("/add-profit-margin")}
                >
                  Add Profit Margin
                </button>
              )}
            </div>
            <hr />
            <div className="row">
              {listData &&
                listData.length > 0 &&
                listData.map((item, index) => (
                  <div className="col-12 mb-4" key={index}>
                    <div className="d-flex mb-1">
                      <div className="d-flex me-auto">
                        <h5 className="mb-0">{item?.freight_type.split("_").join(" ")} </h5>
                        <span className="ms-1">
                          {item?.hasOwnProperty("min_shipment_per_month")
                            ? `${"( " + item.min_shipment_per_month ?? 0}${
                                listData[index + 1]?.hasOwnProperty(
                                  "min_shipment_per_month"
                                )
                                  ? " to " +
                                    (listData[index + 1]
                                      ?.min_shipment_per_month ?? 0) +
                                    " shipment per month"
                                  : " above shipment per month"
                              }` + " / "
                            : ""}    
                        {/* </span>
                        <span className="ms-1"> */}
                          {item?.hasOwnProperty("min_revenue_per_month")
                            ? `${ item.min_revenue_per_month ?? 0}${
                                listData[index + 1]?.hasOwnProperty(
                                  "min_revenue_per_month"
                                )
                                  ? " to " +
                                    (listData[index + 1]
                                      ?.min_revenue_per_month ?? 0) +
                                    " revenue per month"
                                  : " above revenue per month"
                              }` + " )"
                            : ""}
                        </span>
                      </div>
                      {(CheckAccess(212, "edit") ||
                        user_type === "SUPERADMIN") && (
                        <button
                          className="btn btn-info"
                          onClick={() =>
                            history.push(
                              "/edit-profit-margin?id=" + item._id,
                              item
                            )
                          }
                        >
                          Edit
                        </button>
                      )}
                    </div>
                    <div className="table-responsive">
                      <table className="table table-centered table-nowrap mb-0 table-bordered text-center">
                        <thead className="table-light">
                          <tr>
                            {/* <th>S no.</th> */}
                            <th>Freight Amount ( AED )</th>
                            <th>Value of Goods (AED)</th>
                            <th>Profit %</th>
                            <th>Minimum Profit Margin</th>
                          </tr>
                        </thead>
                        <tbody>
                          {item.freight_data.length > 0 &&
                            item.freight_data.map((list, key1) => (
                              <>
                                {list.value_of_goods.map((list1, key) => (
                                  <tr key={key}>
                                    {/* <td scope="row">{key + 1}</td> */}
                                    <td>
                                      {list.freight_from +
                                        " - " +
                                        list.freight_to}
                                    </td>
                                    <td>
                                      {list1.min_goods +
                                        " - " +
                                        list1.max_goods}
                                    </td>
                                    <td>{list1.profit ? list1.profit : "-"}</td>
                                    <td>
                                      {list1.min_profit
                                        ? list1.min_profit
                                        : "-"}
                                    </td>
                                  </tr>
                                ))}
                              </>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))}
            </div>
          </div>
          {Boolean(isDeleteOpen) && (
            <Modal.DeleteItem
              isOpen={Boolean(isDeleteOpen)}
              title="Delete"
              message={`Are you sure want to Delete`}
              onSubmitEvent={() => onDeleteSubmit()}
              handleClose={() => setIsDeleteOpen(false)}
            />
          )}
        </div>
        {/* {listData.length > 0 && pagination.totalRecord > pagination.limit &&
                    <ReactPaginate
                        previousLabel={<img src="assets/images/prev.svg" height={15} alt="not found" />}
                        forcePage={currentPage - 1}
                        nextLabel={<img src="assets/images/next.svg" height={15} alt="not found" />}
                        breakLabel={'...'}
                        breakClassName={'break-me'}
                        pageCount={Math.ceil(pagination.totalRecord / pagination.limit)}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={3}
                        onPageChange={(e) => onPageChangeEvent(e)}
                        containerClassName={'pagination'}
                        activeClassName={'active'}
                    />
                } */}
        <Loader isShow={loader} />
      </div>
    </div>
  );
};
